module.exports = __webpack_public_path__ + "img/Flag_of_Equatorial_Guinea.b05ba675.svg";